import { Separator } from "@/components/ui/separator";
import { motion } from "framer-motion";
import { slideInFromBottom } from "@/lib/animations";

const Footer = () => {
    return (
        <motion.footer 
            className="bg-background/50 border-t border-border/50 backdrop-blur-sm"
            initial="hidden"
            animate="visible"
            variants={slideInFromBottom}
        >
            <div className="container mx-auto py-8 px-4 md:px-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left">
                    <div>
                        <h3 className="font-bold text-lg mb-4">BloxBoost</h3>
                        <p className="text-muted-foreground">The best place to earn Robux for free. Complete offers and get rewarded instantly.</p>
                    </div>
                    <div>
                        <h3 className="font-bold text-lg mb-4">Links</h3>
                        <ul className="space-y-2">
                            <li><a href="/" className="text-muted-foreground hover:text-primary transition-colors">Home</a></li>
                            <li><a href="/earn" className="text-muted-foreground hover:text-primary transition-colors">Earn</a></li>
                            <li><a href="/withdraw" className="text-muted-foreground hover:text-primary transition-colors">Withdraw</a></li>
                            <li><a href="/leaderboard" className="text-muted-foreground hover:text-primary transition-colors">Leaderboard</a></li>
                        </ul>
                    </div>
                    <div>
                        <h3 className="font-bold text-lg mb-4">Legal</h3>
                        <ul className="space-y-2">
                            <li><a href="/terms" className="text-muted-foreground hover:text-primary transition-colors">Terms of Service</a></li>
                            <li><a href="/privacy" className="text-muted-foreground hover:text-primary transition-colors">Privacy Policy</a></li>
                        </ul>
                    </div>
                </div>
                <Separator className="my-8 bg-border/50" />
                <p className="text-center text-muted-foreground">&copy; 2024 BloxBoost. All rights reserved.</p>
            </div>
        </motion.footer>
    );
};

export default Footer;
